import React from 'react';
import { connect } from 'react-redux';
import StatisticsByUTMMetrics from './StatisticsByUTMMetrics.js';
import actions from './StatisticsByUTMMetrics.actions';
import {
    mainSelector,
    getMetrics
} from './StatisticsByUTMMetrics.selectors';
import ReportByUTMComponent from '../../../../utils/ReportByUTMComponent/ReportByUTMComponent';

const reportUtils = ReportByUTMComponent.utils;

const StatisticsByUTMMetricsComponent = connect(
    function mapStateToProps(state, ownProps) {
        const data = mainSelector(state);
        const fallbackMetrics = getMetrics(state);
        const metrics = typeof ownProps.metrics === 'string' && ownProps.metrics.length
            ? ownProps.metrics
            : fallbackMetrics;
        const checkedKeys = reportUtils.getKeysMetric(metrics || reportUtils.getDefStrMetric());

        return {
            data,
            metrics,
            checkedKeys,
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsByUTMMetrics);

export default StatisticsByUTMMetricsComponent;
